<app-loader *ngIf="isLoading"></app-loader>

<div class="main-container lg-view">
    <h3>{{ job.jobName }}</h3>
    <h5 *ngIf="job.projectName" [class.no-margin-bottom]="job.assetName != null">{{ job.projectName }}</h5>
    <h5 *ngIf="job.assetName != null" class="color-inherit">{{job.assetName}}</h5>

    <ng-container
        *ngTemplateOutlet="job.siteAddress ? infoTemplate : null; context: { label: 'Address', text: job.siteAddress }">
    </ng-container>

    <ng-container *ngIf="pageType !== PageType.BoardMember">
        <ng-container
            *ngTemplateOutlet="job.serviceProvider ? infoTemplate : null; context: { label: 'Provider', text: job.serviceProvider }">
        </ng-container>
    </ng-container>

    <ng-container
        *ngTemplateOutlet="pageType === PageType.BoardMember ? infoTemplate : null; context: { label: 'No Later Than', text: job.noLaterThan || '---' }">
    </ng-container>

    <ng-container *ngIf="pageType !== PageType.BoardMember && !job.hasDigitalLogForms">
        <ng-container *ngTemplateOutlet="infoTemplate; context: { label: 'ETA', text: job.jobEta }"></ng-container>
    </ng-container>
</div>

<action-button-carousel [showMessageTemplate]="shouldShowMessageTemplate">

    <ng-template #buttonsTemplate>
        <!-- CUSTOMER buttons -->
        <ng-container *ngIf="pageType === PageType.Customer">

            <action-button *ngIf="!isJobFlowDone && isJobRegular" [clickAction]="navigateWithData.bind(self, 'status')"
                @slideUp @fadeIn [icon]="ButtonIcons.StatusChange" [name]="'Complete'" [disabled]="isJobFlowDone">
            </action-button>

            <action-button *ngIf="!isJobFlowDone && isJobRegular" [clickAction]="navigateWithData.bind(self, 'date')"
                @slideUp @fadeIn [icon]="ButtonIcons.EtaChange" [name]="'Change\nDate'" [disabled]="isJobFlowDone">
            </action-button>

            <action-button [clickAction]="navigateWithData.bind(self, 'document')" [icon]="ButtonIcons.AddDocument"
                *ngIf="isJobRegular || isJobSmartDocs" @slideUp @fadeIn [name]="'Add\nDocument'"></action-button>

            <action-button *ngIf="isJobRegular" [clickAction]="navigateWithData.bind(self, 'notes')" @slideUp @fadeIn
                [icon]="ButtonIcons.Comment" [name]="'My Notes'"></action-button>

            <action-button [clickAction]="navigateWithData.bind(self, 'collaborate')" @slideUp @fadeIn
                *ngIf="isJobRegular" [icon]="ButtonIcons.RequestUpdate" [name]="'Collaborate'"></action-button>

            <action-button *ngIf="isJobRegular" [clickAction]="navigateWithData.bind(self, 'proposals')" @slideUp
                @fadeIn [icon]="ButtonIcons.Comment" [name]="'Proposals'"></action-button>

            <action-button *ngIf="job.hasForms && isJobRegular" [clickAction]="navigateWithData.bind(self, 'forms')"
                @slideUp @fadeIn [icon]="ButtonIcons.MultipleDocuments" [name]="'Forms'"></action-button>

            <action-button *ngIf="isJobDigitalLogbook" [clickAction]="navigateWithData.bind(self, 'digital-log')"
                @slideUp @fadeIn [icon]="ButtonIcons.MultipleDocuments" [name]="'Digital Log'"></action-button>
        </ng-container>

        <!-- ASSIGNEE buttons -->
        <ng-container *ngIf="isAssignee">
            <action-button *ngIf="isJobRegular" [clickAction]="navigateWithData.bind(self, 'document')"
                [icon]="ButtonIcons.AddDocument" @slideUp @fadeIn [name]="'Add\nDocument'"></action-button>

            <action-button *ngIf="isJobRegular" [clickAction]="navigateWithData.bind(self, 'notes')"
                [icon]="ButtonIcons.Comment" @slideUp @fadeIn [name]="'Collaborate'"></action-button>
        </ng-container>

        <!-- VENDOR buttons -->
        <ng-container *ngIf="isVendor">
            <action-button *ngIf="!isJobFlowDone && (isJobRegular || isJobSupport)"
                [clickAction]="navigateWithData.bind(self, 'status')" [icon]="ButtonIcons.StatusChange" @slideUp @fadeIn
                [name]="'Complete'" [disabled]="isJobFlowDone">
            </action-button>

            <!-- <action-button *ngIf="!isJobFlowDone && (isJobRegular || isJobSupport)"
                [clickAction]="navigateWithData.bind(self, 'date')" [icon]="ButtonIcons.EtaChange" @slideUp @fadeIn
                [name]="'Change\nDate'" [disabled]="isJobFlowDone">
            </action-button> -->

            <action-button *ngIf="isJobRegular || isJobSupport || isJobSmartDocs"
                [clickAction]="navigateWithData.bind(self, 'document')" [icon]="ButtonIcons.AddDocument" @slideUp
                @fadeIn [name]="'Add\nDocument'"></action-button>

            <action-button *ngIf="isJobRegular || isJobSupport" [clickAction]="navigateWithData.bind(self, 'notes')"
                [icon]="ButtonIcons.Comment" @slideUp @fadeIn [name]="'Collaborate'"></action-button>

            <action-button *ngIf="job.hasForms && (isJobRegular || isJobSupport)"
                [clickAction]="navigateWithData.bind(self, 'forms')" @slideUp @fadeIn
                [icon]="ButtonIcons.MultipleDocuments" [name]="'Forms'"></action-button>

            <action-button *ngIf="isJobDigitalLogbook" [clickAction]="navigateWithData.bind(self, 'digital-log')"
                @slideUp @fadeIn [icon]="ButtonIcons.MultipleDocuments" [name]="'Digital Log'"></action-button>
        </ng-container>

        <!-- BOARD MEMBER buttons -->
        <ng-container *ngIf="pageType === PageType.BoardMember">
            <action-button [clickAction]="navigateWithData.bind(self, 'property-management')" *ngIf="isJobRegular"
                [icon]="ButtonIcons.People" @slideUp @fadeIn [name]="'Property\nMgmt.'"></action-button>

            <action-button [clickAction]="navigateWithData.bind(self, 'proposals')" [icon]="ButtonIcons.Comment" *ngIf="isJobRegular"
                @slideUp @fadeIn [name]="'Proposals'"></action-button>
        </ng-container>

    </ng-template>

    <ng-template #messagesTemplate>
        <div class="actions-placeholder-message" *ngIf="pageType === PageType.Customer">
            <span
                *ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
                {{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
            <span
                *ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
                {{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
            <span
                *ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
                {{ ActionsPlaceholderSettings.BothDisabled }}</span>
        </div>

        <div class="actions-placeholder-message" *ngIf="BitwiseHelper.and(pageType, PageType.AssigneeOrVendor)">
            <span *ngIf="customerPreferences.preferences.isJobAutoSkipped">{{
                ActionsPlaceholderSettings.JobAutoSkipped
                }}</span>
        </div>
    </ng-template>
</action-button-carousel>

<ng-template #infoTemplate let-label="label" let-text="text">
    <div class="job-details">
        <div class="job-details-text">
            <span class="label">{{ label }}</span>
            <span *ngIf="text">{{ text }}</span>
        </div>
    </div>
</ng-template>